// @ts-nocheck
import {
  faFileExport,
  faPlus,
  faPlusSquare,
  faX
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import FilterButtonGroup, {
  FilterMenu
} from 'components/common/FilterButtonGroup';
import FilterTab, { FilterTabItem } from 'components/common/FilterTab';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import SearchBox from 'components/common/SearchBox';
import ProductsTable, {
  productsTablecolumns
} from 'components/tables/ProductsTable';
import { defaultBreadcrumbItems } from 'data/commonData';
import { productsTableData } from 'data/e-commerce/products';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { Badge, Col, Row } from 'react-bootstrap';
import { ChangeEvent } from 'react';
import { useEffect, useState } from 'react';
import { ToastContainer, toast, Zoom } from 'react-toastify';
import axios from 'axios';
import { getCookie, isAuth } from 'helpers/helpers';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import { ButtonGroup, Dropdown } from 'react-bootstrap';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';

const tabItems: FilterTabItem[] = [
  {
    label: 'All',
    value: 'all',
    count: 68817
  },
  {
    label: 'Published',
    value: 'published',
    count: 70348
  },
  {
    label: 'Drafts',
    value: 'drafts',
    count: 17
  },
  {
    label: 'On discount',
    value: 'on_discount',
    count: 810
  }
];

const filterMenus: FilterMenu[] = [
  {
    label: 'Kategorien',
    items: [
      {
        label: 'Plants'
      },
      {
        label: 'Furniture'
      },
      {
        label: 'Fashion'
      }
    ]
  },
  {
    label: 'Vendor',
    items: [
      {
        label: 'Blue Olive Plant sellers. Inc'
      },
      {
        label: 'Beatrice Furnitures'
      },
      {
        label: 'Kizzstore'
      }
    ]
  }
];

const Products = () => {
  /*   let navigate = useNavigate();

  useEffect(() => {
    !isAuth() && navigate('/auth/sign-in');
  }, []); */

  const [primedecoTableData, setPrimedecoTableData] = useState([]);
  const [uniqueCategories, setUniqueCategories] = useState([]);
  const [categoryFilter, setCategoryFilter] = useState('none');
  const [uniqueColors, setUniqueColors] = useState([]);
  const [colorFilter, setColorFilter] = useState('none');
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchValue, setSearchValue] = useState('');

  const deleteSearchParams = () => {
    setSearchParams({});
  };

  const filterCategories = category => {
    setSearchParams({ category: category, color: colorFilter });
  };

  const filterColors = color => {
    setSearchParams({ category: categoryFilter, color: color });
  };

  useEffect(() => {
    if (!isAuth()) {
    } else {
      const token = getCookie('token');

      axios({
        method: 'post',
        url: process.env.REACT_APP_PRODUCT_API + '/receive-all-products',
        data: { categoryFilter: 'none', colorFilter: 'none' },
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
        .then(response => {
          if (response && response.data && response.data.allProducts) {
            const allProductsArray = response.data.allProducts;

            const uniqueCategoriesArray = uniqueCategoriesArray
              ? [...new Set(allProductsArray.map(item => item.Hauptkategorie))]
              : [];
            setUniqueCategories(uniqueCategoriesArray);

            const uniqueColorsArray = allProductsArray
              ? [...new Set(allProductsArray.map(item => item.Farbe))]
              : [];
            setUniqueColors(uniqueColorsArray);
          }
        })
        .catch(err => {
          console.log('err', err);
        });
    }
  }, []);

  useEffect(() => {
    if (!isAuth()) {
    } else {
      const token = getCookie('token');
      table.setGlobalFilter(undefined);
      setCategoryFilter(
        searchParams && searchParams.get('category')
          ? searchParams.get('category')
          : 'none'
      );
      setColorFilter(
        searchParams && searchParams.get('color')
          ? searchParams.get('color')
          : 'none'
      );

      const categoryFilter =
        searchParams && searchParams.get('category')
          ? searchParams.get('category')
          : 'none';
      const colorFilter =
        searchParams && searchParams.get('color')
          ? searchParams.get('color')
          : 'none';

      if (categoryFilter != 'none' && colorFilter != 'none') {
        axios({
          method: 'post',
          url: process.env.REACT_APP_PRODUCT_API + '/receive-all-products',
          data: { categoryFilter, colorFilter },
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
          .then(response => {
            if (response && response.data && response.data.allProducts) {
              const allProductsArray = response.data.allProducts;

              const uniqueCategoriesArray = allProductsArray
                ? [
                    ...new Set(
                      allProductsArray.map(item => item.Hauptkategorie)
                    )
                  ]
                : [];
              setUniqueCategories(uniqueCategoriesArray);

              const uniqueColorsArray = allProductsArray
                ? [...new Set(allProductsArray.map(item => item.Farbe))]
                : [];
              setUniqueColors(uniqueColorsArray);
            }
          })
          .catch(err => {
            console.log('err', err);
          });
      } else if (categoryFilter != 'none' && colorFilter == 'none') {
        axios({
          method: 'post',
          url: process.env.REACT_APP_PRODUCT_API + '/receive-all-products',
          data: { categoryFilter, colorFilter: 'none' },
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
          .then(response => {
            if (response && response.data && response.data.allProducts) {
              const allProductsArray = response.data.allProducts;

              const uniqueCategoriesArray = allProductsArray
                ? [
                    ...new Set(
                      allProductsArray.map(item => item.Hauptkategorie)
                    )
                  ]
                : [];
              setUniqueCategories(uniqueCategoriesArray);

              const uniqueColorsArray = allProductsArray
                ? [...new Set(allProductsArray.map(item => item.Farbe))]
                : [];
              setUniqueColors(uniqueColorsArray);
            }
          })
          .catch(err => {
            console.log('err', err);
          });
      } else if (categoryFilter == 'none' && colorFilter != 'none') {
        axios({
          method: 'post',
          url: process.env.REACT_APP_PRODUCT_API + '/receive-all-products',
          data: { categoryFilter: 'none', colorFilter: colorFilter },
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
          .then(response => {
            if (response && response.data && response.data.allProducts) {
              const allProductsArray = response.data.allProducts;

              const uniqueCategoriesArray = allProductsArray
                ? [
                    ...new Set(
                      allProductsArray.map(item => item.Hauptkategorie)
                    )
                  ]
                : [];
              setUniqueCategories(uniqueCategoriesArray);

              const uniqueColorsArray = allProductsArray
                ? [...new Set(allProductsArray.map(item => item.Farbe))]
                : [];
              setUniqueColors(uniqueColorsArray);
            }
          })
          .catch(err => {
            console.log('err', err);
          });
      } else if (categoryFilter == 'none' && colorFilter == 'none') {
        axios({
          method: 'post',
          url: process.env.REACT_APP_PRODUCT_API + '/receive-all-products',
          data: { categoryFilter: 'none', colorFilter: 'none' },
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
          .then(response => {
            if (response && response.data && response.data.allProducts) {
              const allProductsArray = response.data.allProducts;

              const uniqueCategoriesArray = allProductsArray
                ? [
                    ...new Set(
                      allProductsArray.map(item => item.Hauptkategorie)
                    )
                  ]
                : [];
              setUniqueCategories(uniqueCategoriesArray);

              const uniqueColorsArray = allProductsArray
                ? [...new Set(allProductsArray.map(item => item.Farbe))]
                : [];
              setUniqueColors(uniqueColorsArray);
            }
          })
          .catch(err => {
            console.log('err', err);
          });
      }
    }
  }, [searchParams]);

  useEffect(() => {
    if (!isAuth()) {
    } else {
      const token = getCookie('token');
      setCategoryFilter(
        searchParams && searchParams.get('category')
          ? searchParams.get('category')
          : 'none'
      );
      setColorFilter(
        searchParams && searchParams.get('color')
          ? searchParams.get('color')
          : 'none'
      );

      const categoryFilter =
        searchParams && searchParams.get('category')
          ? searchParams.get('category')
          : 'none';
      const colorFilter =
        searchParams && searchParams.get('color')
          ? searchParams.get('color')
          : 'none';

      axios({
        method: 'post',
        url: process.env.REACT_APP_PRODUCT_API + '/receive-all-products',
        data: { categoryFilter, colorFilter },
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
        .then(response => {
          if (response && response.data && response.data.allProducts) {
            const allProductsArray = response.data.allProducts;

            const primedecoHelperArray = [];

            allProductsArray.forEach(product => {
              let primedecoTags =
                product.ean_gtins[0] &&
                product.ean_gtins[0].Produktname.split(' | ');

              primedecoHelperArray.push({
                product: product.Titel_Deutsch,
                productImage:
                  product &&
                  product.ean_gtins &&
                  product.ean_gtins[0] &&
                  product.ean_gtins[0].Bild_URL &&
                  product.ean_gtins[0].Bild_URL,
                category:
                  product && product.Hauptkategorie && product.Hauptkategorie,
                tags: primedecoTags,
                starred: false,
                vendor: 'Blue Olive Plant sellers. Inc',
                color: product.Farbe,
                imagenumber: product.Bildnummer,
                ean: product.EAN
              });
            });
            setPrimedecoTableData(primedecoHelperArray);
          }
        })
        .then(() => {
          searchParams &&
            searchParams.get('s') &&
            handleSearchInputChange(searchParams.get('s'), true);
        })
        .catch(err => {
          console.log('err', err);
        });
    }
  }, [searchParams]);

  const table = useAdvanceTable({
    data: primedecoTableData && primedecoTableData,
    columns: productsTablecolumns && productsTablecolumns,
    pageSize: 50,
    pagination: true,
    sortable: true
  });

  const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement>, b) => {
    if (b) {
      table.setGlobalFilter(e || undefined);
    } else {
      table.setGlobalFilter(e.target.value || undefined);
    }
  };

  return (
    <div>
      <div className="mb-9">
        <h2 className="mb-4">Products</h2>

        <AdvanceTableProvider {...table}>
          <div className="mb-4">
            <div className="d-flex flex-wrap gap-3">
              <SearchBox
                placeholder="Produkte durchsuchen"
                onChange={(e, b) => handleSearchInputChange(e, false)}
              />
              <div className="scrollbar overflow-hidden-y">
                {/* <FilterButtonGroup menus={filterMenus} /> */}
                <ButtonGroup className="position-static">
                  <Dropdown
                    key="primecategory"
                    as={ButtonGroup}
                    className="position-static"
                  >
                    <Dropdown.Toggle
                      variant="phoenix-secondary"
                      className="px-7 flex-shrink-0 dropdown-caret-none"
                    >
                      {categoryFilter == 'none' ? 'Kategorien' : categoryFilter}

                      <FontAwesomeIcon
                        icon={faAngleDown}
                        className="ms-2"
                        transform="down-2"
                      />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item
                        key="nocategory"
                        onClick={() => filterCategories('none')}
                      >
                        Keine
                      </Dropdown.Item>
                      {uniqueCategories &&
                        uniqueCategories.map((item, subIndex) => (
                          <Dropdown.Item
                            key={subIndex}
                            onClick={() => filterCategories(item)}
                          >
                            {item}
                          </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                  </Dropdown>

                  <Dropdown
                    key="primecolors"
                    as={ButtonGroup}
                    className="position-static"
                  >
                    <Dropdown.Toggle
                      variant="phoenix-secondary"
                      className="px-7 flex-shrink-0 dropdown-caret-none"
                    >
                      {colorFilter == 'none' ? 'Farben' : colorFilter}
                      <FontAwesomeIcon
                        icon={faAngleDown}
                        className="ms-2"
                        transform="down-2"
                      />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item
                        key="nocolors"
                        onClick={() => filterColors('none')}
                      >
                        Keine
                      </Dropdown.Item>
                      {uniqueColors &&
                        uniqueColors.map((item, subIndex) => (
                          <Dropdown.Item
                            key={subIndex}
                            onClick={() => filterColors(item)}
                          >
                            {item}
                          </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                  </Dropdown>

                  {/*  <Button
                    variant="phoenix-secondary"
                    className="px-7 flex-shrink-0"
                  >
                    More filters
                  </Button> */}
                </ButtonGroup>
                {searchParams.get('s') && (
                  <>
                    <Button
                      variant="primary ms-3"
                      onClick={() => deleteSearchParams()}
                    >
                      {searchParams.get('s') && searchParams.get('s')}
                      <Badge bg="secondary ms-3">
                        <FontAwesomeIcon icon={faX} />
                      </Badge>
                    </Button>
                  </>
                )}
              </div>
              <div className="ms-xxl-auto">
                <Link to="/primedeco/create-new">
                  <Button variant="primary">
                    <FontAwesomeIcon icon={faPlus} className="me-2" />
                    Produkt erstellen
                  </Button>
                </Link>
              </div>
            </div>
          </div>

          <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-body-emphasis border-top border-bottom border-translucent position-relative top-1">
            <ProductsTable />
          </div>
        </AdvanceTableProvider>
      </div>
    </div>
  );
};

export default Products;
